export const ROUTER_PATH = {
    SHOPS: '/shops',
    SHOPS_ID: '/shops/:shopId',
    SHOPS_ID_SERVICES: '/shops/:shopId/services',
    SHOPS_ID_BUNDLES: '/shops/:shopId/bundles',
    SHOPS_ID_BUNDLES_ID: '/shops/:shopId/bundles/:bundleId',
    SHOPS_ID_EVENTS: '/shops/:shopId/events',
    SHOPS_ID_EVENTS_ID: '/shops/:shopId/events/:eventId',
    SHOPS_ID_GROUPS: '/shops/:shopId/groups',
    SHOPS_ID_SUBSCRIPTIONS: '/shops/:shopId/subscriptions',
    SHOPS_ID_SUBSCRIPTIONS_ID: '/shops/:shopId/subscriptions/:subscriptionId',
    RESERVATIONS: '/reservations',
    RESERVATIONS_HISTORY: '/reservations/history',
    RESERVATIONS_DETAILS_TYPE_ID_NEXT: '/reservations/details/:reservationType/:reservationId/:next',
    NOTIFICATIONS: '/notifications',
    NOTIFICATIONS_PROMOTION_ID: '/notifications/promotions/:promotionId',
    PROFILE: '/profile',
    PROFILE_SLASH: '/profile/',
    PROFILE_LOYALTY: '/profile/loyalty',
    PROFILE_SETTINGS: '/profile/settings',
    PROFILE_ACCOUNT: '/profile/account',
    PROFILE_ACCOUNT_PASSWORD: '/profile/account/password',
    SIGN_IN_ROUTE: '/signin/:route',
    SIGN_IN_RESERVATIONS: '/signin/reservations',
    SIGN_IN_PROFILE: '/signin/profile',
    // TODO: redo to /shops/id/category/id
    BUNDLE_ID: '/bundle/:bundleId',
    EVENT_ID: '/event/:eventId',
    BOOK: '/book',
    BOOK_SUCCESS_TYPE: '/book/success/:bookType',
    BOOK_CONFIRM_TYPE: '/book/confirm/:bookType',
    SUBSCRIPTION_DETAILS :'/subscription-details',
};
